import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hfc-add-button',
  templateUrl: './add-button.component.html',
  styleUrls: ['./add-button.component.scss']
})
export class AddButtonComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
